export const bytesToMB = (bytes: number) => {
  const mb = bytes * 0.000001;
  const mbFixed = mb.toFixed(2);
  return mbFixed;
};
